import { Pipe, type PipeTransform } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlSharedPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(html: string): SafeHtml {
    // Default allow-lists/block-lists: https://github.com/cure53/DOMPurify/wiki/Default-TAGs-ATTRIBUTEs-allow-list-&-blocklist
    const clean: string = DOMPurify.sanitize(html, {ADD_ATTR: ['target']});
    return this.sanitizer.bypassSecurityTrustHtml(clean);
  }

}
